import React, { useState } from "react";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
import DataGridComponent from "../../../Components/Forms/DataGridProComponent";
import { TextField } from "@mui/material";
import { Button } from "react-bootstrap";
import parse from 'html-react-parser';

const ConeLogisticoDetalheViagemPopup = (props: any) => {
    const [criterioBusca, setCriterioBusca] = useState('');
    const [pageSize, setPageSize] = useState(20);
    const [responseRows, setResponseRows] = useState<any>();

    const colunas: any[] = [
        { dataIndex: 'viagem_id', title: 'Id Viagem', minWidth: 100, flex: 0.2, },
        { dataIndex: 'viagem_status', title: 'Status de ocorrência', minWidth: 150, flex: 0.2, },
        { dataIndex: 'operacao_nome', title: 'Operação', minWidth: 200, flex: 0.1, },
        { dataIndex: 'valor', title: 'Valor', render: (value: any) =>  `R$ ${value}` },
        { dataIndex: 'tipo_viagem', title: 'Tipo', minWidth: 200, flex: 0.1, },
        { dataIndex: 'mercadoria_nome', title: 'Mercadoria', minWidth: 200, flex: 0.1, },
        { dataIndex: 'motorista_nome', title: 'Motorista', minWidth: 250, flex: 0.1, },
        { dataIndex: 'veiculo_placa', title: 'Placa', minWidth: 100, flex: 0.1, },
        { dataIndex: 'veiculo_tecnologia', title: 'Tecnologia', minWidth: 100, flex: 0.2, },
        { dataIndex: 'detalhes', title: 'Nome da ocorrência',  minWidth: 400, flex: 0.3, },
        { dataIndex: 'mapa_coordenadas', title: 'Mapa', render: (value: string) => parse(`${(value ?? '')}`) },
        { dataIndex: 'origem_nome', title: 'Origem', minWidth: 250, flex: 0.1, },
        { dataIndex: 'destino_nome', title: 'Destino', minWidth: 250, flex: 0.1, },
    ];

    async function atualizaListaBuscaCallBack(pageSize: number, pageNumber: number = 1) {
        setPageSize(pageSize);

        try {
            console.log('verificarID');
            let ids = '';

            document.body.style.cursor = "wait";

            let response = await axios.post(`coneLogisticoDetalhes`,
                { 'page': pageNumber, 'pageSize': pageSize, 'ids': props.ids, 'criterio': criterioBusca, 'usarRegraId': props.usarRegraId??false });

            if (response?.data == null) {
                document.body.style.cursor = "default";
                return null;
            }

            setResponseRows(response);
        } catch (error) {
            console.log(error);
            document.body.style.cursor = "default";
        }
        finally {
            document.body.style.cursor = "default";
        }
    }

    function concat(string1: string, string2: string) {
        let string1Invalida = string1 == null || string1 == '';
        let string2Invalida = string2 == null || string2 == '';
        if (string1Invalida && string2Invalida) {
            return '';
        }

        if (string2Invalida) {
            return string1;
        }

        if (string1Invalida) {
            return string2;
        }

        return string1 + ',' + string2;
    }

    return (
        <div>
            <BasePopup title="Dados Ocorrências" isOpen={props.isOpen} onClose={props.onClose} hideButtonNew={true}>
                <span className="area-busca">
                    <TextField
                        onChange={(e) => setCriterioBusca(e.target.value)}
                        id="outlined-basic"
                        label="Busca"
                        variant="outlined"
                        className="col-md-9 col-12"
                        style={{ paddingRight: 10 }} />

                    <Button
                        onClick={async () => await atualizaListaBuscaCallBack(pageSize)}
                        style={{ marginTop: 10 }}
                        variant="contained"
                        className="col-md-3">
                        Buscar
                    </Button>
                </span>

                <DataGridComponent
                    heightFix={250}
                    responseRows={responseRows}
                    paginationSide="server"
                    hideButtons={true}
                    columns={colunas}
                    atualizaListaBuscaCallBack={atualizaListaBuscaCallBack} />
            </BasePopup>
        </div>
    );
}

export default ConeLogisticoDetalheViagemPopup;
